var React = require('react');

function Baleh (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.47,6.55c.68-.08,1.42.52,1.96.89.6.41,1.17.86,1.76,1.28.07,0,.49-.31.6-.37,5.16-3.15,11.73-2.07,15.45,2.71,4.89,6.29,2.1,15.56-5.37,18.17s-15.23-2.79-15.51-10.59c-.13-3.61.1-7.29,0-10.91.05-.6.5-1.1,1.11-1.18ZM21.2,20.32c.99-.98,1.96-1.98,2.95-2.96.6-.6,1.18-.99,1.32-1.91.31-2.09-2.08-3.43-3.72-2.11l-5.28,5.27-.08-.02c-.75-.74-1.46-1.51-2.24-2.21-2.21-1.46-4.67,1.18-3.09,3.28,1.29,1.22,2.51,2.71,3.84,3.87.91.79,2.17.82,3.08.01,1.09-.97,2.18-2.18,3.22-3.22Z"}));
}

Baleh.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 36 36"};

module.exports = Baleh;

Baleh.default = Baleh;
